import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  proposalId: string
}

export type ItemsWithDiscount = {
  id: string | number
  productId: string
  name: string
  configurationDescription?: string
  discount: number
  maximumDiscount: number
  defaultPrice: number
  salePrice: number
}

export type OrderLineItem = {
  productId?: string
  name?: string
  product?: { id?: string; name?: string }
  configurationDescription?: string
  quantity?: number | string
  salePrice?: number
}

export type OrderReviewReasonsData = {
  payment?: string
  delivery?: string
  itemsWithDiscount?: ItemsWithDiscount[]
  minimalOrder?: string
  minimalFreight?: string
  dirtRoadQuiz?: string | boolean
  canApprove?: number
  proposal?: {
    cdPedidoReserva?: string
    products?: OrderLineItem[]
    customer?: {
      uf?: string
    }
  }
}

type ReviewReasons = {
  data: OrderReviewReasonsData
}

type Response = Promise<ReviewReasons>

const loadOrderReviewReasons = (data: Params): Response => {
  return axios.get(`/orders/proposals/${data.proposalId}/motives`)
}

export function useLoadOrderReviewReasons(query: Params) {
  return useQuery(
    ['orderReviewReasons', query],
    () => loadOrderReviewReasons(query),
    {
      enabled: !!query.proposalId,
      onError: () =>
        toast.error('Não foi possível carregar os motivos de análise!', {
          toastId: 'loadOrderReviewReasons'
        })
    }
  )
}
